import { AxiosResponse } from 'axios';
import { PAYMENT } from '@constants/api';
import { SessionRequest } from '@store/checkout/interfaces/sessionRequest';
import { securePost } from "@store/services/axiosRequestWrapper";

export async function createAdyenSession(apiEndpoint: string, apiToken: string, locale: string, data: SessionRequest): Promise<AxiosResponse> {
    return await securePost(apiEndpoint + PAYMENT + 'Adyen/CreateSession', apiToken, locale, data);
}
